import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from 'primeng/api';
import { SelectItem } from "primeng/components/common/selectitem";
import { CreateFlashCouponModel } from "../../../../models/inModels/flashcoupon";
import { AuthenticationService } from "../../../../services/authentication/authentication.service";
import { FlashCouponService } from "../../../../services/flash/flash-coupon-service";
import { StorageService } from "../../../../services/system/storage.service";
import { FlashService } from "../../../../services/flash/flash.service";
import { FlashProduct } from "../../../../models/inModels/Flash";

@Component({
	selector: 'app-create-flash-coupon',
	templateUrl: './create-flash-coupon.component.html',
	styleUrls: ['./create-flash-coupon.component.css']
})
export class CreateFlashCouponComponent  {
	model: CreateFlashCouponModel;
	loading = false;
	error: Message[];
	messages: Message[];
	products: SelectItem[];
	selectedProduct: SelectItem;
	flashProduct: FlashProduct;
	constructor(
		private storageService: StorageService,
		private auth: AuthenticationService,
		private router: Router,
		private service: FlashCouponService,
		private flashService: FlashService,) {
		this.model = new CreateFlashCouponModel();
	}

	initDropDown(event) {
		this.flashService.getDropdown(event).then(
			x => {
				this.products = x;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setProduct(): void {
		this.loading = true;
		this.model.ProductCode = this.selectedProduct.value;
		this.flashService.get(this.selectedProduct.value).then(
			result => {
				console.log(result);
				this.flashProduct = result;
				this.model.Amount = null;
				if (this.flashProduct.Min === this.flashProduct.Max) {
					this.model.Amount = this.flashProduct.Min/100;
				}
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	goBack(): void {
		this.router.navigate(['/flash/coupons']);
	}

	save() {
		this.loading = true;
		this.service.create(this.model).then(
			result => {
				this.loading = false;
				this.router.navigate(['/flash/coupons']);
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/flash/flash-coupons/create-flash-coupon/create-flash-coupon.component.ts